(() => {
  'use strict';

  const params = new URLSearchParams(window.location.search);
  const selectedOptions = [];
  for (let index = 1; index <= 3; index += 1) {
    const name = params.get(`option_name_${index}`);
    const value = params.get(`option_value_${index}`);
    if (name && value && name.length <= 255 && value.length <= 512) selectedOptions.push({ name, value });
  }
  const summarize = options => options.length === 1 ? options[0].value : options.map(option => `${option.name}: ${option.value}`).join('; ');
  const finish = summarize(selectedOptions.filter(option => /finish|colou?r|metal|material|plating/i.test(option.name)));
  const size = summarize(selectedOptions.filter(option => /size|length|width|diameter|measurement/i.test(option.name)));
  const optionsText = selectedOptions.map(option => `${option.name}: ${option.value}`).join('\n');
  let productURL = '';
  try {
    const suppliedURL = params.get('product_url');
    if (suppliedURL) {
      const supplied = new URL(suppliedURL, window.location.origin);
      if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//i.test(supplied.pathname)) {
        const url = new URL(supplied.pathname, window.location.origin);
        const variant = params.get('variant') || supplied.searchParams.get('variant');
        if (variant && /^\d+$/.test(variant)) url.searchParams.set('variant', variant);
        productURL = url.toString();
      }
    }
  } catch (_) { productURL = ''; }

  const fill = (field, value) => {
    if (!field || !value || field.value || field.dataset.inquiryEdited === 'true') return;
    if (field.tagName === 'SELECT' && !Array.from(field.options).some(option => option.value === value)) {
      field.add(new Option(value, value));
    }
    field.value = value;
  };
  const initialize = (scope = document) => {
    const forms = Array.from(scope.querySelectorAll('.jmo-contact-form'));
    if (scope.matches?.('.jmo-contact-form')) forms.unshift(scope);
    forms.forEach(form => {
      if (!form.querySelector('[data-inquiry-finish]') || form.dataset.inquiryInitialized === 'true') return;
      form.dataset.inquiryInitialized = 'true';
      form.querySelectorAll('input, select, textarea').forEach(field => {
        const preserveEdit = () => { field.dataset.inquiryEdited = 'true'; };
        field.addEventListener('input', preserveEdit);
        field.addEventListener('change', preserveEdit);
      });
      fill(form.querySelector('[data-piece-request]'), params.get('piece') || params.get('product'));
      fill(form.querySelector('[data-inquiry-finish]'), finish);
      fill(form.querySelector('[data-inquiry-size]'), size);
      fill(form.querySelector('[data-inquiry-options]'), optionsText);
      fill(form.querySelector('[data-inquiry-url]'), productURL);
      form.querySelectorAll('[data-inquiry-options-field], [data-inquiry-url-field]').forEach(field => {
        if (field.querySelector('input, textarea')?.value) field.hidden = false;
      });
    });
  };
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const destination = new URL(link.href, window.location.href);
    const current = new URL(window.location.href);
    if (destination.hash !== '#design-request' || destination.origin !== current.origin || destination.pathname !== current.pathname || destination.searchParams.get('view') !== current.searchParams.get('view')) return;
    const form = document.querySelector('#design-request');
    const input = form?.querySelector('[data-piece-request]');
    if (!input) return;
    event.preventDefault();
    fill(input, (destination.searchParams.get('piece') || '').slice(0, 200));
    const menu = link.closest('[data-header-details]');
    if (menu) menu.open = false;
    if (window.location.hash !== '#design-request') window.location.hash = 'design-request';
    form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    input.focus({ preventScroll: true });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
